import React from 'react';
import { Route, Switch } from "react-router-dom";
import MakerReportsModule from './rr-maker-reports-module/maker-reports-module';

const RRMakerReports = () => {
  return (
    <Switch>
      <Route exact path="/adhoc-reports">
        <MakerReportsModule />
      </Route>
    </Switch>
  )
}

export default RRMakerReports;



